import type { TranslationTree } from '../../types';

export const toolPickers: TranslationTree = {
  toolPickers: {
    reference: {
      placeholder: 'Search or type a reference',
      listTitle: 'Existing references · {{count}}',
      empty: 'No reference',
      toolCount: { one: '{{count}} tool', other: '{{count}} tools' },
      current: 'current',
      create: 'Create the new reference “{{reference}}”',
      hint: 'Pick an existing reference. A value that is not in the list creates a new reference.',
      currentHint: "The tool's current reference.",
      existing: 'Existing reference · {{tools}}',
      existingAlias: 'Existing reference · {{tools}} · alias “{{alias}}”',
      nearTitle: 'Similar reference:',
      near: '{{reference}} already exists ({{tools}}). As typed, “{{value}}” creates a new reference.',
      use: 'Use {{reference}}',
      newTitle: 'New reference.',
      new: '“{{value}}” does not exist yet: it will be created with this tool.',
    },
    toolId: {
      listTitle: "Company's tools · {{count}}",
      empty: 'No tool matches',
      more: 'and {{count}} more: refine the search',
      noReference: 'no reference',
      traces: { none: 'no record', one: '{{count}} record', other: '{{count}} records' },
      lastTrace: 'last on {{date}}',
      known: 'Reference {{reference}} · {{traces}}',
      knownNoReference: 'No reference · {{traces}}',
      near: 'No tool “{{value}}”. Did you mean {{toolId}}?',
      use: 'Use',
      unknown: 'No tool “{{value}}” in your company.',
      create: 'Create this tool',
    },
    existingIds: {
      hint: 'IDs already registered appear as you type.',
      takenTitle: 'This tool already exists',
      taken: '(reference {{reference}}, {{traces}}). An ID can only be registered once.',
      openTool: "Open {{toolId}}'s page and change its reference →",
      near: '{{toolId}} already exists: only the case or separators differ. Check the tool marking.',
      listTitle: 'IDs already registered · {{count}}',
      more: 'and {{count}} more',
      nextFree: 'Next free number:',
      use: 'Use',
      takenShort: "{{toolId}} already exists: change its reference on the tool's page.",
      takenElsewhere: 'This ID is already registered by another company.',
    },
    edit: {
      button: 'Edit',
      buttonLabel: 'Edit the reference',
      label: 'New reference of {{toolId}}',
      note: "The tool's records do not change. Only its grouping does.",
      move: "The tool's records do not change. In the tool list it leaves {{from}} ({{left}} remain) for {{to}}.",
      moveLast:
        "The tool's records do not change. In the tool list it leaves {{from}}, which will have no tool left, for {{to}}.",
      newReference: '{{reference}} (new)',
      save: 'Save',
      cancel: 'Cancel',
      saved: 'Reference changed: {{from}} → {{to}}.',
      savedNew: 'Reference changed: {{from}} → {{to}} (new reference created).',
      error: 'The reference could not be changed.',
    },
  },
};
